import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {delay, takeUntil, tap} from 'rxjs/operators';
import {CONTRACT_OWNER_OFWCA, CONTRACT_OWNER_PARTNER, DictService} from '../../../shared/services/dict.service';
import {of, ReplaySubject} from 'rxjs';
import {Contract} from '../../../shared/interface/contract';
import {PartnerService} from '../../../shared/services/partner.service';
import {ListResponse} from '../../../shared/interface/response/list-response';
import {OfwcaService} from '../../../shared/services/ofwca.service';
import {DictPartnersComponent} from '../../../shared/components/dict-partners/dict-partners.component';

@Component({
  selector: 'app-contract-select-card',
  templateUrl: './contract-select-card.component.html',
  styleUrls: ['./contract-select-card.component.scss']
})
export class ContractSelectCardComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private dictPartnersComponent: ReplaySubject<DictPartnersComponent>
    = new ReplaySubject<DictPartnersComponent>(1);

  readonly CONTRACT_OWNER_PARTNER = CONTRACT_OWNER_PARTNER;

  @Input() control: FormControl;

  ownerControl: FormControl;
  ofwcaControl: FormControl;
  partnerControl: FormControl;
  requiredPartner = false;
  requiredOfwca = false;
  contracts: Contract[] = [];

  constructor(
    private fb: FormBuilder,
    private dictService: DictService,
    private partnerService: PartnerService,
    private ofwcaService: OfwcaService,
  ) {
    this.ownerControl = fb.control('', [Validators.required]);
    this.ofwcaControl = fb.control('', [Validators.required]);
    this.partnerControl = fb.control('', [Validators.required]);
  }

  ngOnInit(): void {
    this.ownerControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe(dictId => {
        // this.dictService.getKey(dictId)
        //   .subscribe((dictKey: string) => {
            // if (dictKey === CONTRACT_OWNER_OFWCA) {
            //   this.requireOfwca();
            //   this.loadOfwcaContracts();
            // } else {
              this.requirePartner();
              this.loadPartnerContracts();
            // }
          // });
      });

    this.partnerControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => {
        this.loadPartnerContracts();
      });

    this.ofwcaControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => {
        this.loadOfwcaContracts();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  requireOfwca(): void {
    this.ofwcaControl.setValidators([Validators.required]);
    this.partnerControl.setValidators([]);
    this.ofwcaControl.enable();
    this.partnerControl.reset();
    this.partnerControl.disable();
    this.requiredOfwca = true;
    this.requiredPartner = false;
  }

  requirePartner(): void {
    this.partnerControl.setValidators([Validators.required]);
    this.ofwcaControl.setValidators([]);
    this.partnerControl.enable();
    this.ofwcaControl.reset();
    this.ofwcaControl.disable();
    this.requiredOfwca = false;
    this.requiredPartner = true;
  }

  loadOfwcaContracts(): void {
    if (!this.ofwcaControl.value) {
      this.contracts = [];
      return;
    }

    this.ofwcaService.getOfwcaContracts(this.ofwcaControl.value)
      .subscribe((contracts: ListResponse<Contract>) => {
        this.contracts = contracts.items;
      });
  }

  loadPartnerContracts(): void {
    if (!this.partnerControl.value) {
      this.contracts = [];
      return;
    }

    this.partnerService.getPartnerContracts(this.partnerControl.value)
      .subscribe((contracts: ListResponse<Contract>) => {
        this.contracts = contracts.items;
      });
  }

  initialize(contract: Contract): void {
    of(contract)
      .pipe(
        delay(0),
        tap(() => {
          this.ownerControl.setValue(contract.owner.id);
        }),
        delay(0),
        tap(() => {
          if (contract.ofwca) {
            this.ofwcaControl.setValue(contract.ofwca.uuid);
          }
        }),
        tap(() => {
          if (contract.partner) {
            this.partnerControl.setValue(contract.partner.uuid);
          }
        }),
        delay(0),
        tap(() => {
          this.control.setValue(contract.uuid);
        })
      )
      .subscribe();
  }
}
